/* eslint-disable prettier/prettier */
import React from "react";
import { Container, Grid, Paper, Typography, Box } from "@mui/material";

// 👉 Replace with your actual QR image path
import phonepeQR from "assets/images/plain-img1.jpg";
import cardBg from "assets/images/plain-img3.jpg";

function Payment() {
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 6 }}>
      
      {/* Page Title */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h3" fontWeight="bold">
          📜 “ದಾನಂ ಧರ್ಮಸ್ಯ ಮೂಲಂ”
        </Typography>
        <Typography variant="subtitle1" mt={1} color="#0c0c0c" fontWeight={700}>
           ದಾನವೇ ಧರ್ಮದ ಶ್ರೇಷ್ಠ ರೂಪ
        </Typography>
      </Box>

     <Grid container spacing={4} alignItems="stretch">

  {/* PhonePe / UPI Card */}
  <Grid item xs={12} md={6} sx={{ display: "flex" }}>
    <Paper
      elevation={4}
      sx={{
        p: 3,
        borderRadius: 3,
        textAlign: "center",
        backgroundImage: `linear-gradient(
          rgba(218, 178, 70, 0.35),
          rgba(231, 211, 110, 0.85)
        ), url(${cardBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography variant="h5" mb={2} fontWeight="bold">
        📱 ಫೋನ್ ಪೆ QR ಕೋಡ್
      </Typography>

      <Box
        component="img"
        src={phonepeQR}
        alt="PhonePe QR"
        sx={{
          width: "100%",
          maxWidth: 220,
          mx: "auto",
          mb: 2,
          borderRadius: 2,
          boxShadow: 3,
        }}
      />

      <Typography fontSize={14} fontWeight="bold">
        ಮೇಲಿನ QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ದಾನ ಸಲ್ಲಿಸಬಹುದು
      </Typography>

      <Typography mt={1} fontWeight="bold">
        UPI ID:{" "}
        <span style={{ color: "#08173b" }}>
          yourupi@bank
        </span>
      </Typography>
    </Paper>
  </Grid>

  {/* Bank Details Card */}
  <Grid item xs={12} md={6} sx={{ display: "flex" }}>
    <Paper
      elevation={4}
      sx={{
        p: 3,
        borderRadius: 3,
        backgroundImage: `linear-gradient(
          rgba(218, 178, 70, 0.35),
          rgba(231, 211, 110, 0.85)
        ), url(${cardBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography
        variant="h5"
        mb={2}
        fontWeight="bold"
        textAlign="center"
      >
        🏦 ಬ್ಯಾಂಕ್ ವಿವರಗಳು
      </Typography>

      <Typography variant="h6">
        <b>ಖಾತೆ ಹೆಸರು:</b> ಶ್ರೀ ಅಂಬಾ ಭವಾನಿ ದೇವಾಲಯ
      </Typography>
      <Typography variant="h6">
        <b>ಖಾತೆ ಸಂಖ್ಯೆ:</b> XXXXXXXXXXXX
      </Typography>
      <Typography variant="h6">
        <b>ಬ್ಯಾಂಕ್ ಹೆಸರು:</b> XXXXX ಬ್ಯಾಂಕ್
      </Typography>
      <Typography variant="h6">
        <b>ಶಾಖೆ:</b> ಹುಲಿಕೆರೆ
      </Typography>
      <Typography variant="h6">
        <b>IFSC:</b> XXXXXXXX
      </Typography>
    </Paper>
  </Grid>

</Grid>


      {/* Thank You Message */}
      <Box textAlign="center" mt={5}>
        <Box textAlign="center" mt={3}>
              <Typography fontSize={18} fontWeight="bold">
                🙏 ದಾನ ಸಲ್ಲಿಸಿದವರಿಗೆ ಧನ್ಯವಾದಗಳು🙏
              </Typography>
            </Box>
        <Typography fontSize={18} fontWeight="bold">
           🌸 ನಿಮ್ಮ ದಾನವೇ ದೇವಾಲಯದ ನಿರಂತರ ಸೇವೆಗೆ ಶಕ್ತಿ🌸
        </Typography>
      </Box>
    </Container>
  );
}

export default Payment;
